<template>
  <section class="container">
    <div class="header">
      <span class="header__question">
        您遇到了什么问题？
      </span>
      <span class="header__service">
        请选择您问题的类型
      </span>
    </div>
    <div v-for="(item, index) in menuList" :key="index" class="content">
      <div class="whiteLine"></div>
      <van-cell-group :title="item.text">
        <van-collapse v-model="item.index">
          <van-collapse-item v-for="(items) in item.subtitle" :key="items.index" :title="items.text">
            {{items.content}}
          </van-collapse-item>
        </van-collapse>
      </van-cell-group>
    </div>
    <!-- <div class="service">
      <a :href="`tel:${phone}`">客服:{{this.phone}} </a>
    </div> -->
  </section>
</template>

<script>
import { Collapse, CollapseItem, CellGroup } from 'vant'
import config from '@/config/index'
export default {
  name: 'CustomerService',
  components: {
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [CellGroup.name]: CellGroup
  },
  data () {
    return {
      phone: this.$enumObject.providerConfig[config.projectName].servicePhone,
      activeNames: ['1'],
      menuList: [
        {
          icon: 'balance-list-o',
          text: '计费问题',
          url: '',
          index: [],
          subtitle: [
            {
              text: '计费规则',
              index: 1,
              content: '您好，平台仅为车场提供既定停车费的线上缴费技术服务，所有缴费规则均为车场管理人员设置。'
            }
          ]
        },
        {
          icon: 'after-sale',
          text: '持续计费',
          index: [],
          url: '',
          subtitle: [{
            index: 2,
            text: '车辆掉头、倒车被识别入场',
            content: '您好，若您的车辆未进场，请联系客服。'
          }, {
            index: 4,
            text: '车场发生故障，车辆放行后仍持续计费',
            content: '您好，若您的车辆未进场，请联系客服。'
          }, {
            index: 3,
            text: '车辆已出场，仍持续计费',
            content: '您好，若您的车辆未进场，请联系客服。'
          }],
        },
        {
          icon: 'label-o',
          text: '电子发票',
          index: [],
          url: '',
          subtitle: [{
            index: 5,
            text: '如何开具发票',
            content: '您好，您可以前往我的钱包，进行开票'
          }, {
            index: 6,
            text: '我找不到可开具的发票',
            content: '（1）时间超过3个月的订单（2）未开通电子发票服务的车场（3）使用非本公众号缴费的订单（4）使用非微信支付的订单'
          }, {
            index: 7,
            text: '开票时，邮箱填写错误导致未收到发票',
            content: '您好，请点击开票历史重新开票'
          }
            , {
            index: 8,
            text: '如何回到出单结果页面直接开票？',
            content: '如果退出出单结果页面，将无法直接开具'
          }],
        },
        // {
        //   icon: 'logistics',
        //   text: '月租车',
        //   index: [],
        //   url: '',
        //   subtitle: [{
        //     index: 8,
        //     text: '如何充值月租车',
        //     content: ''
        //   }, {
        //     index: 9,
        //     text: '无法充值月租车',
        //     content: '您好，如果您是首次充值月租车需要您的车辆在车场登记后，才能够进行月租车充值。'
        //   }, {
        //     index: 10,
        //     text: '充值月租车时，有效时间段有误',
        //     content: '您好，月租车有效时间段是车场人员在收费系统中直接设置的，无法从线上充值页面直接更改，若车场工作人员设置的开始时间和结束时间有误，建议您直接向车场工作人员咨询进行修改~'
        //   }],
        // },
        // {
        //   icon: 'failure',
        //   text: '缴费异常',
        //   url: '',
        // },
        // {
        //   icon: 'debit-pay',
        //   text: '无感支付',
        //   url: '',
        // },
        {
          icon: 'replay',
          text: '重复缴费',
          index: [],
          url: '',
          subtitle: [{
            index: 11,
            text: '已使用现金缴纳停车费，仍收到停车费用订单',
            content: '您好，该问题可能是您在线下向车场工作人员缴纳了现金，车场管理人员未给您录入停车费用导致，客服这边是无法查询不到您下线的现金订单的。'
          }, {
            index: 12,
            text: '我已经开通了月租车，还收到停车费用账单',
            content: '您好，该问题可能是由于月租车生效时间为开通月卡之后，您本次入场的时间是在开通月卡之前，因此本次停车费用是需要缴纳的哦~'
          }, {
            index: 13,
            text: '车场做免费停车活动，我仍收到停车费用账单',
            content: '您好，该问题可能是车场做免费活动时，但车场管理人员未给您的车牌移除费用造成的，小P这边是难以核实车场线下活动的，若您已缴费，您需要到车场管理处咨询并退款，给您带来不便，十分抱歉~~'
          }],
        }
        // ,
        // {
        //   icon: 'more-o',
        //   text: '其他',
        //   index: [],
        //   url: '',
        //   subtitle: [{
        //     index: 11,
        //     text: '客服联系方式',
        //     content: this.$enumObject.providerConfig[config.projectName].servicePhone
        //   }],
        // }
      ]
    }
  },
  methods: {
    // 跳转
    linkComponents () {
      this.$toast('暂未开通 敬请期待！')
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  .service {
    display: flex;
    justify-content: center;
    font-size: 16px;
    margin-bottom: 10px;
  }
  .whiteLine {
    background-color: #f5f5f5;
    height: 5px;
  }
  .header {
    height: 100px;
    padding: 0 15px 0;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-content: center;
    margin-bottom: 10px;
    &__question {
      font-size: 22px;
      font-family: SourceHanSansCN-Bold;
      font-weight: bold;
      line-height: 26px;
    }
    &__service {
      font-size: 14px;
      font-family: SourceHanSansCN-Bold;
      font-weight: bold;
      line-height: 18px;
      color: #999;
    }
  }
}
</style>
